<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8Z"
      fill="#EDEDFC"
    />
    <path
      d="M17 15V19M15 17H19M18 29V33M16 31H20M25 15L27.2857 21.8571L33 24L27.2857 26.1429L25 33L22.7143 26.1429L17 24L22.7143 21.8571L25 15Z"
      stroke="#4545D0"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: "24",
  },
  height: {
    type: [String, Number],
    default: "24",
  },
  color: {
    type: String,
    default: "#4545D0",
  },
  strokeWidth: {
    type: [String, Number],
    default: "2",
  },
});
</script>
